export const visit = (vm, at) => {
vm(require("./availability/de.lyaml"));
vm(require("./typical-response-time/de.lyaml"));
vm(require("./default/de.lyaml"));
at({ "de": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "OK" } } });
};